module.exports = __webpack_public_path__ + "static/media/PB_Y_09.2ffb6114.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/yellow/PB_Y_09.png
// module id = 238
// module chunks = 0